var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriteriaSurveyAccessLinks", {
        attrs: { viewModel: _vm.criteriaSurveyAccessLinks },
        on: {
          "show-email-sender": _vm.showCriteriaSurveyEmailSender,
          "download-links": _vm.handleDownloadAccessLinks,
        },
      }),
      _vm._v(" "),
      _c("CriteriaSurveyEmailSender", {
        attrs: { viewModel: _vm.criteriaSurveyEmailSender },
        on: { "send-email": _vm.handleSendEmailCommand },
      }),
      _vm._v(" "),
      _c("CriterionDetailsDialog", {
        attrs: { viewModel: _vm.criterionDetailsDialog },
      }),
      _vm._v(" "),
      _c("MeetingStarterDialog", {
        attrs: {
          propOpened: _vm.meetingStarterOpened,
          propSurveyStarted: _vm.SurveyStarted,
          propAutoRevealEnabled: _vm.AutoRevealEnabled,
          propNamesRevealed: _vm.NamesRevealed,
        },
        on: {
          "start-meeting": _vm.handleStartMeetingCommand,
          "start-survey": _vm.handleStartSurveyCommand,
          "stop-survey": _vm.handleStopSurveyCommand,
          "toggle-auto-reveal": _vm.ToggleAutoRevealCommand,
          "toggle-names-revealed": _vm.ToggleNamesRevealedCommand,
          "show-access-links": _vm.ShowAccessLinksCommand,
          "close-dialog": function ($event) {
            _vm.meetingStarterOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("MeetingStopperDialog", {
        attrs: {
          propOpened: _vm.meetingStopperOpened,
          propSurveyStarted: _vm.SurveyStarted,
        },
        on: {
          "stop-meeting": _vm.handleStopMeetingCommand,
          "start-survey": _vm.handleStartSurveyCommand,
          "stop-survey": _vm.handleStopSurveyCommand,
          "close-dialog": function ($event) {
            _vm.meetingStopperOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("DisagreementsReportDialog", {
        attrs: {
          propOpened: _vm.disagreementsReportOpened,
          propRm: _vm.disagreementReport,
        },
        on: {
          "show-question": _vm.handleShowDisagreementsQuestion,
          "close-dialog": function ($event) {
            _vm.disagreementsReportOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("PanelConsistencyAnalysisDialog", {
        attrs: {
          propOpened: _vm.consistencyAnalysisOpened,
          propRm: _vm.consistencyAnalysis,
        },
        on: {
          "show-question": _vm.handleShowInconsistentQuestion,
          "close-dialog": function ($event) {
            _vm.consistencyAnalysisOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("SurveyOpenerDialog", {
        attrs: {
          propOpened: _vm.surveyOpenerOpened,
          propSurveyId: _vm.surveyId,
        },
        on: {
          "start-survey": _vm.handleStartSurveyCommand,
          "show-access-links": _vm.ShowAccessLinksCommand,
          "close-dialog": function ($event) {
            _vm.surveyOpenerOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("SurveyCloserDialog", {
        attrs: {
          propOpened: _vm.surveyCloserOpened,
          propSurveyId: _vm.surveyId,
        },
        on: {
          "stop-survey": _vm.handleStopSurveyCommand,
          "close-dialog": function ($event) {
            _vm.surveyCloserOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.initialized === false ? [_vm._m(0)] : _vm._e(),
      _vm._v(" "),
      _vm.initialized
        ? [
            _c(
              "nav",
              {
                staticClass:
                  "navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center",
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-group", attrs: { role: "group" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.PreviousQuestionCommand },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Prev question")]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.AllQuestionsAnswered === false
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: {
                              type: "button",
                              title: "Go to next unanswered question",
                            },
                            on: { click: _vm.NextUnansweredQuestionCommand },
                          },
                          [
                            _vm._v(
                              "\n                    Next unanswered\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.AllQuestionsAnswered === true
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: {
                              type: "button",
                              title: "Go to next unanswered question",
                            },
                            on: { click: _vm.AllDoneCommand },
                          },
                          [
                            _vm._v(
                              "\n                    All done\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.NextQuestionCommand },
                      },
                      [
                        _c("span", [_vm._v("Next question")]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-chevron-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-fluid",
                staticStyle: { "padding-top": "130px" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("h6", { staticClass: "mx-5" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "sanitizedHref",
                              rawName: "v-sanitizedHref",
                              value: _vm.url_Criteria_WeightsPage,
                              expression: "url_Criteria_WeightsPage",
                            },
                          ],
                          staticClass: "text-dark",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-double-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" Back to weights\n                        "),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass: "my-0 mx-5",
                        staticStyle: {
                          "font-size": "2em",
                          "font-weight": "300",
                          color: "#33475b",
                        },
                      },
                      [_vm._v("Panel: " + _vm._s(_vm.Name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-6 col-lg-5 text-right col align-self-end",
                    },
                    [
                      _vm.MeetingStarted === false
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: { click: _vm.showMeetingStarterCommand },
                              },
                              [_vm._v("Start Meeting")]
                            ),
                            _vm._v(" "),
                            _vm.SurveyStarted === false
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.surveyOpenerOpened = true
                                      },
                                    },
                                  },
                                  [_vm._v("Open Survey")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.SurveyStarted === true
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.surveyCloserOpened = true
                                      },
                                    },
                                  },
                                  [_vm._v("Close Survey")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.ShowAccessLinksCommand },
                              },
                              [
                                _vm._v(
                                  "\n                            Access links\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Analyze votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.showDisagreementsReport,
                                      },
                                    },
                                    [_vm._v("Disagreements")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.showConsistencyAnalysis,
                                      },
                                    },
                                    [_vm._v("Consistency")]
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.MeetingStarted === true
                        ? _c("div", [
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning",
                                  attrs: { type: "button" },
                                  on: { click: _vm.ToggleVotesRevealedCommand },
                                },
                                [
                                  _c("i", {
                                    class:
                                      _vm.VotesRevealed === true
                                        ? "fa-regular fa-fw fa-square-check"
                                        : "fa-regular fa-fw fa-square",
                                  }),
                                  _vm._v(
                                    " Reveal votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("button", {
                                staticClass:
                                  "btn btn-warning dropdown-toggle dropdown-toggle-split",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item px-1",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.ToggleAutoRevealCommand.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          _vm.AutoRevealEnabled === true
                                            ? "fa-regular fa-fw fa-square-check"
                                            : "fa-regular fa-fw fa-square",
                                      }),
                                      _vm._v(
                                        " Auto reveal\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item px-1",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.ToggleNamesRevealedCommand.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          _vm.NamesRevealed === false
                                            ? "fa-regular fa-fw fa-square-check"
                                            : "fa-regular fa-fw fa-square",
                                      }),
                                      _vm._v(
                                        " Anonymous\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Analyze votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.showDisagreementsReport,
                                      },
                                    },
                                    [_vm._v("Disagreements")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.showConsistencyAnalysis,
                                      },
                                    },
                                    [_vm._v("Consistency")]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Actions\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          _vm.meetingStopperOpened = true
                                        },
                                      },
                                    },
                                    [_vm._v("Stop Meeting")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "dropdown-divider",
                                  }),
                                  _vm._v(" "),
                                  _vm.SurveyStarted === false
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              _vm.surveyOpenerOpened = true
                                            },
                                          },
                                        },
                                        [_vm._v("Open Survey")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.SurveyStarted === true
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              _vm.surveyCloserOpened = true
                                            },
                                          },
                                        },
                                        [_vm._v("Close Survey")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.ShowAccessLinksCommand },
                                    },
                                    [_vm._v("Access links")]
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("hr", {
                  staticStyle: {
                    "border-color": "#bbb",
                    margin: "20px 0 60px",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-lg-3 col-md-3 col-sm-4 col-xs-12",
                      staticStyle: { "padding-bottom": "100px" },
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n                            Questions "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.AnsweredQuestionsCount) +
                                "/" +
                                _vm._s(_vm.QuestionsCount)
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "dropdown" }, [
                            _c(
                              "a",
                              {
                                staticClass: "h5 dropdown-toggle",
                                staticStyle: { "white-space": "normal" },
                                attrs: { "data-toggle": "dropdown" },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.CurrentContext?.Name) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                staticStyle: {
                                  "max-height": "300px",
                                  "overflow-y": "auto",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group px-3 mb-1" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.SearchPhrase,
                                          expression: "SearchPhrase",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "search",
                                        placeholder: "Search...",
                                      },
                                      domProps: { value: _vm.SearchPhrase },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.SearchPhrase = $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(1),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.EvalContextsView, function (c) {
                                  return _c(
                                    "a",
                                    {
                                      key: c.CriterionId,
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.SetCurrentContext(
                                            c.CriterionId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(c.Name)
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("small", [_vm._v(_vm._s(c.Path))]),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "list-group mt-2" },
                            _vm._l(_vm.QuestionsView, function (q) {
                              return _c(
                                "a",
                                {
                                  key: q.QuestionId,
                                  staticClass:
                                    "list-group-item list-group-item-action",
                                  class: {
                                    "bg-secondary text-white":
                                      _vm.CurrentQuestionId === q.QuestionId,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.SwitchQuestion(q.QuestionId)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: _vm.getQuestionCssClass(q),
                                  }),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(q.FirstCriterionName) +
                                      " vs. " +
                                      _vm._s(q.SecondCriterionName) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12",
                      staticStyle: { "padding-bottom": "100px" },
                    },
                    [
                      _c("MeetingQuestionReview", {
                        attrs: { readModel: _vm.Question },
                        on: {
                          "show-criterion-details": _vm.showCriterionDetails,
                          "update-value": _vm.handleSavePanelVoteCommand,
                          "update-comment":
                            _vm.handleSavePanelVoteCommentCommand,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "container-fluid",
        staticStyle: { "padding-top": "130px" },
      },
      [
        _c("h3", [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Loading..."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }